// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr-obj-subinline-label-hidden > .ant-form-item-row > .ant-form-item-label {\n  visibility: hidden;\n}\n.fr-obj-subinline-background > .ant-form-item-row > .ant-form-item-control {\n  background-color: #f6f6f6;\n  padding: 24px 24px 0 24px;\n  border-radius: 4px;\n}\n.fr-obj-subinline .ant-form-item-row {\n  flex-wrap: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
